/* eslint-disable */
export default {
  to: 'Vast.',
  enterNameOrNumber: 'Anna nimi tai numero',
} as const;

// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter name or number"@#@
